<template>
  <div>
    <GmapMap 
      v-if="ads.length" 
      :center="{lat:48.308617, lng:14.280679}" 
      :zoom="10" map-type-id="roadmap" 
      style="min-width: 400px; min-height: 500px;"
    >
      <GmapMarker
        v-for="(m, index, adr) in ads"
        :key="index"
        :position="m"
        :clickable="true"
        @click="toggleInfoWindow(m,index, adr)"
      />

      <gmap-info-window
        :options="infoOptions"
        :position="infoWindowPos"
        :opened="infoWinOpen"
        @closeclick="infoWinOpen=false"
      >
        <div v-html="infoContent"></div>
      </gmap-info-window>
      
    </GmapMap>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      infoContent: '',
        infoWindowPos: {
          lat: 0,
          lng: 0
        },
        infoWinOpen: false,
        currentMidx: null,
        //optional: offset infowindow so it visually sits nicely on top of our marker
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35
          }
        },
    }
  },
  props: ['ads'],
  computed: {
    ...mapState(['baustellen'])
  },
  methods: {
      toggleInfoWindow: function (marker, idx) {
        this.infoWindowPos = marker;
        this.infoContent = this.getInfoWindowContent(marker);
        

        //check if its the same marker that was selected if yes toggle
        if (this.currentMidx == idx) {
          this.infoWinOpen = !this.infoWinOpen;
        }
        //if different marker set infowindow to open and reset current marker index
        else {
          this.infoWinOpen = true;
          this.currentMidx = idx;
        }
      },
      getInfoWindowContent: function(marker) {
         return (`<div class="card">
          <div class="card-content">
            <div class="media">
              <div class="media-content">
                <p class="title is-4">${marker.adr}</p>
              </div>
            </div>
          </div>
        </div>`);
      }
  }
}
</script>

<style scoped>

</style>